import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Grid, Theme, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ReactNode, useEffect } from 'react';
import { StageState } from '../../../types/type';
import './StepProgressBar.css';

interface StepProgressBarState {
  children?: ReactNode | undefined;
  stateInfo: StageState[];
}

const checkCircleStyle: React.CSSProperties = {
  height: '2rem',
  width: '2rem',
};

const stageNameStyle: React.CSSProperties = {
  fontSize: '13px',
  color: '#000',
  width: '100%',
  whiteSpace: 'normal',
  textAlign: 'center',
  overflow: 'hidden',
};

function getStages(state: StageState, theme: Theme, index: number) {
  const stepperStyles = {
    width: '100%',
    '--line-border-fill': theme.custom.styles.progressStepperComplete,
    '--line-border-empty': theme.custom.styles.progressStepperBackground,
    '--circle-skipped': theme.custom.styles.progressStepperSkipped,
  };

  const stage = (
    <div className={`stepper-item ${state.showProgress ? 'completed' : ''}`} key={index} style={stepperStyles}>
      <div className="step-counter">
        <div className="completedView">
          {/* If completed and active, show checkmark */}
          {state.completed && state.viewActive && (
            <CheckCircleIcon
              sx={{
                ...theme.custom.styles.confirmationSuccessIcon,
                ...checkCircleStyle,
                color: theme.custom.styles.progressStepperComplete,
              }}
            ></CheckCircleIcon>
          )}
          {/* If completed and NOT active, show checkmark */}
          {state.completed && !state.viewActive && (
            <CheckCircleIcon
              sx={{
                ...theme.custom.styles.confirmationSuccessIcon,
                ...checkCircleStyle,
                color: theme.custom.styles.progressStepperComplete,
              }}
            ></CheckCircleIcon>
          )}
          {/* If NOT completed but active, DONT show checkmark */}
          {!state.completed && state.viewActive && (
            <div
              style={{
                background: theme.custom.styles.progressStepperComplete,
              }}
              className="completedView "
            ></div>
          )}
          {/* If NOT completed, NOT active, NOT skipped, show gray circle */}
          {!state.completed && !state.viewActive && !state.skipped && (
            <div
              style={{
                background: theme.custom.styles.progressStepperBackground,
              }}
              className="completedView"
            ></div>
          )}
        </div>
      </div>
      <div className="step-name">
        <Typography
          sx={{
            ...theme.custom.styles.primaryDescription,
            ...stageNameStyle,
            fontWeight: state.viewActive ? '700' : '400',
          }}
        >
          {state.name}
        </Typography>
      </div>
    </div>
  );
  return stage;
}

const StepProgressBar = (props: StepProgressBarState) => {
  let progress: null | HTMLElement;
  let circles: any[] | NodeListOf<Element>;
  const theme: Theme = useTheme();
  useEffect(() => {
    circles = document.querySelectorAll('div.circle');
    progress = document.getElementById('progress');
  }, []);

  return (
    <Box
      title="progressBar"
      sx={{
        marginTop: '1em',
        marginBottom: '2em',
        width: '100%',
      }}
    >
      <Grid sx={{ minWidth: '310px' }}>
        <div className="stepper-wrapper">
          {props.stateInfo && props.stateInfo.map((state, index) => getStages(state, theme, index))}
        </div>
      </Grid>
    </Box>
  );
};

export default StepProgressBar;
